import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(VSelect, {
        staticClass: "ma-4",
        attrs: {
          label: "Filter Mode",
          items: [
            { text: "Process Type", value: "process" },
            { text: "Product", value: "product" },
          ],
          "hide-details": "",
          dense: "",
        },
        on: { change: _vm.filter },
        model: {
          value: _vm.filterMode,
          callback: function ($$v) {
            _vm.filterMode = $$v
          },
          expression: "filterMode",
        },
      }),
      _vm.filterMode === "process"
        ? _c(VAutocomplete, {
            staticClass: "ma-4",
            attrs: {
              label: "Process Type",
              placeholder: "Filter by process type",
              "hide-details": "",
              dense: "",
              items: _vm.availableProcessTypes,
              "item-text": "name",
              "item-value": "id",
            },
            on: { change: _vm.filter },
            model: {
              value: _vm.selectedProcessType,
              callback: function ($$v) {
                _vm.selectedProcessType = $$v
              },
              expression: "selectedProcessType",
            },
          })
        : _vm._e(),
      _vm.filterMode === "product"
        ? _c(
            "div",
            [
              _c(VAutocomplete, {
                staticClass: "ma-4",
                attrs: {
                  label: "Input Products",
                  placeholder: "Filter by input products",
                  multiple: "",
                  dense: "",
                  "hide-details": "",
                  items: _vm.allInputProducts,
                },
                on: { change: _vm.filter },
                model: {
                  value: _vm.selectedInputProducts,
                  callback: function ($$v) {
                    _vm.selectedInputProducts = $$v
                  },
                  expression: "selectedInputProducts",
                },
              }),
              _c(VAutocomplete, {
                staticClass: "ma-4",
                attrs: {
                  label: "Output Products",
                  placeholder: "Filter by output products",
                  multiple: "",
                  dense: "",
                  "hide-details": "",
                  items: _vm.allOutputProducts,
                },
                on: { change: _vm.filter },
                model: {
                  value: _vm.selectedOutputProducts,
                  callback: function ($$v) {
                    _vm.selectedOutputProducts = $$v
                  },
                  expression: "selectedOutputProducts",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(VDataTable, {
        staticClass: "inventory-details",
        attrs: {
          headers: _vm.headers,
          items: _vm.flatData,
          "item-key": "name",
        },
        scopedSlots: _vm._u(
          [
            !_vm.isMobile
              ? {
                  key: "header",
                  fn: function ({}) {
                    return [
                      _c("thead", [
                        _c("tr", [
                          _c("th"),
                          _c(
                            "th",
                            {
                              class: _vm.mode.inputs.expanded
                                ? "text-center"
                                : "",
                              attrs: {
                                colspan: _vm.mode.inputs.expanded
                                  ? _vm.inputProducts.size + 1
                                  : 1,
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.summary.inputs"
                                    )
                                  ) +
                                  " "
                              ),
                              _c(
                                VIcon,
                                {
                                  directives: [
                                    { def: Ripple, name: "ripple", rawName: "v-ripple" },
                                  ],
                                  on: {
                                    click: () => {
                                      _vm.mode.inputs.expanded =
                                        !_vm.mode.inputs.expanded
                                      _vm.filter()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.mode.inputs.expanded
                                          ? "mdi-minus-box-outline"
                                          : "mdi-plus-box-outline"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "th",
                            {
                              class: _vm.mode.outputs.expanded
                                ? "text-center"
                                : "",
                              attrs: {
                                colspan: _vm.mode.outputs.expanded
                                  ? _vm.outputProducts.size + 1
                                  : 1,
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.summary.outputs"
                                    )
                                  ) +
                                  " "
                              ),
                              _c(
                                VIcon,
                                {
                                  directives: [
                                    { def: Ripple, name: "ripple", rawName: "v-ripple" },
                                  ],
                                  on: {
                                    click: () => {
                                      _vm.mode.outputs.expanded =
                                        !_vm.mode.outputs.expanded
                                      _vm.filter()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.mode.outputs.expanded
                                          ? "mdi-minus-box-outline"
                                          : "mdi-plus-box-outline"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "th",
                            {
                              staticClass: "text-center",
                              attrs: { colspan: 2 },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.summary.summary"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("th"),
                        ]),
                      ]),
                    ]
                  },
                }
              : null,
            {
              key: "header.group",
              fn: function ({}) {
                return [
                  _c(VSelect, {
                    attrs: {
                      label: _vm.$vuetify.lang.t("$vuetify.summary.groupBy"),
                      dense: "",
                      "hide-details": "",
                      items: [
                        {
                          text: _vm.$vuetify.lang.t("$vuetify.summary.process"),
                          value: "process",
                        },
                        {
                          text: _vm.$vuetify.lang.t("$vuetify.base.date"),
                          value: "date",
                        },
                      ],
                    },
                    on: { change: _vm.filter },
                    model: {
                      value: _vm.groupBy,
                      callback: function ($$v) {
                        _vm.groupBy = $$v
                      },
                      expression: "groupBy",
                    },
                  }),
                ]
              },
            },
            _vm.groupBy == "process"
              ? {
                  key: "item.group",
                  fn: function ({ item }) {
                    return [
                      _c(
                        "a",
                        {
                          attrs: {
                            target: "_blank",
                            href: `${_vm.backofficeUrl}/factory/process/${item.group}`,
                          },
                        },
                        [_vm._v(" " + _vm._s(item.code) + " ")]
                      ),
                    ]
                  },
                }
              : null,
            {
              key: "item.inputTotal",
              fn: function ({ item }) {
                return [
                  _c("div", { staticClass: "totalCell" }, [
                    _vm._v(_vm._s(_vm._f("formatNumber")(item.inputTotal))),
                  ]),
                ]
              },
            },
            {
              key: "item.outputTotal",
              fn: function ({ item }) {
                return [
                  _c("div", { staticClass: "totalCell" }, [
                    _vm._v(_vm._s(_vm._f("formatNumber")(item.outputTotal))),
                  ]),
                ]
              },
            },
            {
              key: "item.delta",
              fn: function ({ item }) {
                return [
                  _c("div", { staticClass: "totalCell" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("formatNumber")(item.delta)) +
                        " (" +
                        _vm._s(
                          _vm._f("formatPercent")(
                            item.outputTotal / item.inputTotal,
                            2
                          )
                        ) +
                        ") "
                    ),
                  ]),
                ]
              },
            },
            {
              key: "item.totalProcessTime",
              fn: function ({ item }) {
                return [
                  _c("div", { staticClass: "totalCell" }, [
                    item.totalProcessTime
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s((item.totalProcessTime / 60).toFixed(1)) +
                              " " +
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.summary.hours")
                              ) +
                              " "
                          ),
                        ])
                      : _c("span", [_vm._v(" N/A ")]),
                    _c("div", { staticClass: "text-caption" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("formatDateTime")(item.firstInputTime)
                          ) +
                          " - " +
                          _vm._s(
                            _vm._f("formatDateTime")(item.lastOutputTime)
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                ]
              },
            },
            {
              key: "body.append",
              fn: function ({}) {
                return [
                  _c(
                    "tr",
                    [
                      _c("th", [
                        _vm._v(
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.total"))
                        ),
                      ]),
                      _vm.mode.inputs.expanded
                        ? _vm._l(_vm.inputProducts, function (input, index) {
                            return _c("th", { key: index }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatNumber")(
                                      _vm.inProductTotals[`in-${input}`]
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          })
                        : _vm._e(),
                      _c("th", [
                        _vm._v(_vm._s(_vm._f("formatNumber")(_vm.totalInputs))),
                      ]),
                      _vm.mode.outputs.expanded
                        ? _vm._l(_vm.outputProducts, function (output, index) {
                            return _c("th", { key: index }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatNumber")(
                                      _vm.outProductTotals[`out-${output}`]
                                    )
                                  ) +
                                  " (" +
                                  _vm._s(
                                    _vm._f("formatPercent")(
                                      _vm.outProductTotals[`out-${output}`] /
                                        _vm.totalInputs,
                                      2
                                    )
                                  ) +
                                  ") "
                              ),
                            ])
                          })
                        : _vm._e(),
                      _c("th", [
                        _vm._v(
                          _vm._s(_vm._f("formatNumber")(_vm.totalOutputs))
                        ),
                      ]),
                      _c("th", [
                        _vm._v(
                          _vm._s(_vm._f("formatNumber")(_vm.totalDelta)) +
                            " (" +
                            _vm._s(
                              _vm._f("formatPercent")(
                                _vm.totalOutputs / _vm.totalInputs,
                                2
                              )
                            ) +
                            ")"
                        ),
                      ]),
                      _c("th", [
                        _vm.totalProcessTime
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (_vm.totalProcessTime / 60).toFixed(1)
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.summary.hours"
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    2
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }